<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <div class="logo">
          <i class="fas fa-cubes"></i>
        </div>
        <h2>PHẦN MỀM LÒ GẠCH</h2>
        <p>Đăng nhập để tiếp tục quản lý</p>
      </div>

      <div class="login-form">
        <div class="form-group" :class="{ 'focused': focusedField === 'phone' }">
          <label><i class="fas fa-phone-alt"></i> Số điện thoại</label>
          <input 
            type="text" 
            v-model="phone" 
            placeholder="Nhập số điện thoại" 
            @focus="focusedField = 'phone'" 
            @blur="focusedField = ''"
            @keyup.enter="handleLogin"
          >
        </div>

        <div class="form-group" :class="{ 'focused': focusedField === 'password' }">
          <label><i class="fas fa-lock"></i> Mật khẩu</label>
          <div class="password-input">
            <input 
              :type="showPassword ? 'text' : 'password'" 
              v-model="password" 
              placeholder="Nhập mật khẩu" 
              @focus="focusedField = 'password'" 
              @blur="focusedField = ''"
              @keyup.enter="handleLogin"
            >
            <i 
              class="fas" 
              :class="showPassword ? 'fa-eye-slash' : 'fa-eye'" 
              @click="showPassword = !showPassword"
            ></i>
          </div>
        </div>

        <div class="form-options">
          <label class="remember-me">
            <input type="checkbox" v-model="rememberMe">
            <span>Ghi nhớ đăng nhập</span>
          </label>
        </div>

        <button class="login-btn" @click="handleLogin" :disabled="loading">
          <span v-if="!loading">ĐĂNG NHẬP</span>
          <i v-else class="fas fa-spinner fa-spin"></i>
        </button>
      </div>

      <div class="login-footer">
        <p>&copy; 2024 Phần mềm Quản lý Lô Gạch. All rights reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      phone: '',
      password: '',
      rememberMe: true,
      showPassword: false,
      loading: false,
      focusedField: ''
    }
  },
  methods: {
    handleLogin() {
      if (!this.phone || !this.password) {
        this.$toast ? this.$toast('Vui lòng nhập đầy đủ thông tin') : alert('Vui lòng nhập đầy đủ thông tin');
        return;
      }

      // MOCK LOGIN
      setTimeout(() => {
          this.loading = false;
          // Accept any login for demo
          const mockAuth = {
              token: 'mock-token-123',
              user: {
                  id: 'user1',
                  name: 'Admin Demo',
                  phone: this.phone,
                  role: 'admin',
                  avatar: 'https://i.pravatar.cc/100'
              }
          };
          
          // this.$root.setAuth(mockAuth);
          
          // // Set Role Cookie for Router Permissions
          // const Base64 = require('base-64');
          // this.$cookie.set('opt_role', Base64.encode('admin'), 1);

          // this.$toast ? this.$toast('Đăng nhập (Demo) thành công') : alert('Đăng nhập (Demo) thành công');
          // this.$router.push({ name: 'home' });


          this.$root.login(this.phone, this.password).then(res => {
              console.log('Login result:', res);
              if (res.status === 'OK' || res.data?.status === 'OK') {
                const auth = res.auth || res.data?.auth;
                this.$emit('login-success', auth);
              } else {
                this.$notify(res.message || 'Lỗi đăng nhập', 'error');
              }
          }).catch(err => {
              console.log('Login error:', err);
              this.$notify(err, 'error');
          });

      }, 1000);

      // OLD API CALL CODE
      /*
      this.$root.api.post('app/login', {
        username: this.phone,
        password: this.password
      })
      .then(res => {
        this.loading = false;
        if (res.data.status === 'OK' || res.data.status === 'success') {
           this.$root.setAuth(res.data.auth);
           this.$router.push({ name: 'home' });
        } else {
           this.$root.showError(res.data.message || 'Đăng nhập thất bại');
        }
      })
      .catch(err => {
        this.loading = false;
        this.$root.showError(err);
      });
      */
    }
  }
}
</script>
